import { Tip } from '../tip/tip';
import styles from "./card-content.module.css"
export const CardContent = ({ category_img, category_name, products = [] }) => {

    return (
        <div className={styles.CardContent_container}>
            <div className={styles.CardContent_name}>
                <div className={styles.CardContent_img}>
                    {category_img}
                </div>
                <p className={styles.CardContent_text}>{category_name}</p>
            </div>
            <div className={styles.CardContent_tip}>
                {
                    products?.products?.map((item, index) => {
                        return <Tip key={index} item={item} />
                    })}
            </div>
        </div>
    );
};